import React from 'react';
import { styled } from '@mui/material/styles';
import MaterialButton from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MaterialButtonGroup from '@mui/material/ButtonGroup';
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Autocomplete } from '@mui/material';
import { getFieldKey } from "../helpers/functions";
// TODO deprecate all components from here
export const colors = {
  dark: {
    text: '#fff',
    reverseText: '#000',
    borderPrimary: '#fff',
    borderSecondary: '#333',
    borderLight: '#1b3847',
    borderLighter: '#2a546b',
    primary: '#10242C',
    lightPrimary: '#0c1c23',
    darkPrimary: '#09151a',
    secondary: '#474747',
    accent: '#ffcc1b',
    accentUnderlay: '#dbb018',
    checkBox: '#fff',
  },
  light: {
    text: '#000',
    reverseText: '#fff',
    borderPrimary: '#000',
    borderSecondary: '#eee',
    borderLight: '#ddd',
    borderLighter: '#ddd',
    primary: '#fff',
    lightPrimary: '#cccccc',
    darkPrimary: '#999999',
    secondary: '#ccc',
    accent: '#ffcc1b',
    checkBox: '#ddd',
  },
};

const styles = {
  homeTextInput: {
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 0,
  },
  rowTitle: {
    marginLeft: 5,
    marginRight: 5,
    fontWeight: 700,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '30%',
  },
  rowText: {
    marginLeft: 5,
    marginRight: 5,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  inputContainer: {
    margin: 5,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputFillContainer: {
    margin: 5,
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  centeredRowContainer: {
    marginLeft: 5,
    marginRight: 5,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
};

const outlinedInputStyles = {
  root: {
    '& .MuiOutlinedInput-input': {
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 5,
      paddingRight: 5,
      fontSize: 14,
    },
  },
};

const accentInputStyle = {
  root: {
    '& label.Mui-focused': {
      color: '#071b24',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#071b24',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: colors.dark.text,
      },
      '&:hover fieldset': {
        borderColor: '#071b24',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#071b24',
      },
    },
  },
};

export const CssFormControl = styled(FormControl)(accentInputStyle.root);
const CssTextField = styled(TextField)(outlinedInputStyles.root);

export const MaterialCheckbox = styled(Checkbox)({
  color: '#fff',
  '&.Mui-checked': {
    color: '#fff',
  },
});

export const ColorLinearProgress = styled(LinearProgress)({
  backgroundColor: '#ffedad',
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#ffcc1b',
  },
});

export function Button(props) {
  const { color, ...other } = props;
  return (
    <MaterialButton
      variant="outlined"
      sx={{
        background: '#90caf9',
        width: '12em',
        fontSize: { xs: '0.6em', sm: '0.7em', md: '0.9em' },
        color: '#000',
        borderStyle: 'none',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
      }}
      {...other}
    />
  );
}

export function ButtonGroup(props) {
  const { color, ...other } = props;
  return (
    <MaterialButtonGroup
      style={{ backgroundColor: '#ffcc1b' }}
      size="medium"
      fullWidth
      {...other}
    />
  );
}

export function TextInput(props) {
  const { color, className, labelClass, slotProps, ...other } = props;
  const fieldKey = getFieldKey(other.id, other.name, other.label, props.input?.label);
  const fieldId = other.id || `input-${fieldKey}`;
  const fieldName = other.name || fieldKey;
  const ariaLabel = other.label || props.input?.label || fieldName;
  return (
    <CssTextField
      //required={true}
      hiddenLabel={true}
      variant="outlined"
      id={fieldId}
      name={fieldName}
      className={className}
      sx={{ width: '100%', fontSize: 14 }}
      slotProps={{
        ...slotProps,
        htmlInput: {
          ...slotProps?.htmlInput,
          'aria-label': slotProps?.htmlInput?.['aria-label'] || ariaLabel,
          className: [slotProps?.htmlInput?.className, labelClass]
            .filter(Boolean)
            .join(' ') || undefined,
        },
      }}
      {...other}
    />
  );
}

export function RowTitle(props) {
  return (
    <Box sx={styles.rowTitle}>
      <p style={{ margin: 0, padding: 0 }}>{props.title}</p>
    </Box>
  );
}

export function RowText(props) {
  return (
    <Box sx={styles.rowText}>
      <p style={{ margin: 0, padding: 0, ...props.textStyle }}>{props.title}</p>
    </Box>
  );
}

export function RowTextInput(props) {
  const { value, input, label, className, labelClass, ...other } = props;
  return (
    <Box sx={input.fill ? styles.inputFillContainer : styles.inputContainer}>
      <TextInput
        label={input && input.label ? input.label : ''}
        error={input && input.error ? true : false}
        value={value ?? (input && input.value ? input.value : '')}
        hiddenLabel={input && input.error ? false : true}
        labelClass={labelClass}
        className={className}
        {...other}
      />
    </Box>
  );
}

export function HomeTextField(props) {
  const { input, ...other } = props;
  return (
    <TextInput
      sx={styles.homeTextInput}
      variant={'outlined'}
      label={input && input.label ? input.label : ''}
      error={input && input.error ? true : false}
      value={input && input.value ? input.value : ''}
      {...other}
    />
  );
}

export function FormTextField(props) {
  const { input = {}, label, items, labelClass, ...other } = props;
  return (
    <Box sx={styles.centeredRowContainer}>
      <CssFormControl sx={{ width: '100%', fontSize: 14, marginTop: 2, marginBottom: 1 }}>
        <TextInput
          variant={'standard'}
          label={input && input.label ? input.label : ''}
          error={input && input.error ? true : false}
          value={input && input.value ? input.value : ''}
          {...other}
        />
        {input.error ? (
          <FormHelperText className={'MuiFormHelperText-root Mui-error'}>
            {input.error}
          </FormHelperText>
        ) : null}
      </CssFormControl>
    </Box>
  );
}

export function RowSelect(props) {
  const { input = {}, label, value, items, labelClass, ...other } = props;
  const fieldKey = getFieldKey(input.key, input.label, label, other.id, other.name);
  const selectLabelId = `select-label-${fieldKey}`;
  const selectId = other.id || `select-${fieldKey}`;
  return (
    <Box sx={styles.centeredRowContainer}>
      <CssFormControl sx={{ width: '100%', fontSize: 14, marginTop: 2, marginBottom: 1 }}>
        <InputLabel id={selectLabelId} htmlFor={selectId} className={input.error ? 'Mui-error' : ''}>
          {label ?? input.label}
        </InputLabel>
        <Select
          displayEmpty
          labelId={selectLabelId}
          id={selectId}
          name={other.name || fieldKey}
          value={value ? value : input.value ? input.value : ''}
          label={label ?? input.label}
          {...other}
        >
          {items}
        </Select>
        {input.error ? (
          <FormHelperText className={'MuiFormHelperText-root Mui-error'}>
            {input.error}
          </FormHelperText>
        ) : null}
      </CssFormControl>
    </Box>
  );
}

export function MultiSelect(props) {
  const { input = {}, label, value, items, labelClass, ...other } = props;
  const fieldKey = getFieldKey(input.key, input.label, label, other.id, other.name);
  const fieldId = other.id || `multiselect-${fieldKey}`;

  return (
    <Box sx={styles.centeredRowContainer}>
      <CssFormControl sx={{ width: '100%', fontSize: 14, marginTop: 2, marginBottom: 1 }}>
        <Autocomplete
          multiple
          id={fieldId}
          options={items}
          getOptionLabel={(option) => option.label}
          filterSelectedOptions
          value={value}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          {...other}
          renderInput={(params) => (
            <TextField
              {...params}
              id={fieldId}
              name={other.name || fieldKey}
              label={label ?? input.label}
            />
          )}
          onChange={(e, value) => props.onChange(value.map((item) => item.value))}
        />
        {input.error ? (
          <FormHelperText className={'MuiFormHelperText-root Mui-error'}>
            {input.error}
          </FormHelperText>
        ) : null}
      </CssFormControl>
    </Box>
  );
}

export function RowDatePicker(props) {
  const { input, label, className, labelClass, format, onChange, slotProps, ...other } = props;
  const fieldKey = getFieldKey(input?.key, input?.label, label, other.id, other.name);
  const fieldId = other.id || `date-${fieldKey}`;
  return (
    <Box sx={styles.centeredRowContainer}>
      <CssFormControl sx={{ width: '100%', fontSize: 14, marginTop: 2, marginBottom: 1 }}>
        <DatePicker
          className={className}
          label={label ? label : input.label}
          value={input && input.value ? input.value : null}
          onChange={(date) => onChange(date)}
          format={format || 'DD/MM/YYYY'}
          slotProps={{
            ...slotProps,
            textField: {
              id: fieldId,
              name: other.name || fieldKey,
              ...slotProps?.textField,
            },
          }}
          {...other}
        />
        {input.error ? (
          <FormHelperText className={'MuiFormHelperText-root Mui-error'}>
            {input.error}
          </FormHelperText>
        ) : null}
      </CssFormControl>
    </Box>
  );
}

export function RowCheckbox(props) {
  const { input = {}, label, value, labelClass, ...other } = props;
  return (
    <Box sx={styles.centeredRowContainer}>
      <FormControlLabel
        style={{ marginTop: 16, marginBottom: 8 }}
        id={'checkbox-label-' + input.label}
        label={label ?? input.label}
        labelPlacement="start"
        control={
          <Checkbox
            id={'checkbox-' + input.label}
            checked={value ? value : input.value ? input.value : false}
            {...other}
          />
        }
      />
    </Box>
  );
}

export function StatusText(props) {
  const { text } = props;
  return text ? (
    <Box sx={styles.inputContainer}>
      <Box component="p" sx={{ marginBottom: 0, fontWeight: 700, fontSize: { xs: '1.1em', md: '1.2em' } }}>
        {text}
      </Box>
    </Box>
  ) : null;
}
